import React from "react";
import { connect } from "react-redux";
import * as interviewActions from "../../../actions/interviewActions";
import { Formik } from "formik";
import { validationSchema } from "./validationSchema";
import { PersonalForm } from "./PersonalForm";
import * as formService from "../../../services/formsService";
import { isNotNullOrWhitespace } from "../../../services/stringService";
import * as moment from "moment";

const InterviewPersonal = ({
    onSubmit,
    onError,
    entry,
    encounterStatus,
    lookups,
    customerJurisdictions,
    counties,
    navigateToNextPage,
    encounterSource,
    documentTypes,
    documents,
    isLoading,
}) => {
    const onFakeSubmit = formData => {
        return Promise.resolve();
    };

    const onFormSubmit = formData => {
        formData = {
            ...formData,
            patient: {
                ...formData.patient,
                maritalStatus: formData.patient.isMarried ? "Married" : "Single",
            },
        };

        if (formData.isResponsiblePartyDifferentFromPatient) {
            formData = {
                ...formData,
                responsibleParty: {
                    ...formData.responsibleParty,
                    maritalStatus: formData.responsibleParty.isMarried ? "Married" : "Single",
                },
            };
        }

        if (formData.patient.documentInfo?.documentType === "Other") {
            formData = {
                ...formData,
                patient: {
                    ...formData.patient,
                    documentInfo: {
                        ...formData.patient.documentInfo,
                        documentType: formData.patient.documentInfo.documentTypeOther,
                    },
                },
            };
            delete formData.patient.documentInfo.documentTypeOther;
        }

        if (formData.responsibleParty?.documentInfo?.documentType === "Other") {
            formData = {
                ...formData,
                responsibleParty: {
                    ...formData.responsibleParty,
                    documentInfo: {
                        ...formData.responsibleParty.documentInfo,
                        documentType: formData.responsibleParty.documentInfo.documentTypeOther,
                    },
                },
            };
            delete formData.responsibleParty.documentInfo.documentTypeOther;
        }

        return onSubmit(formData)
            .then(result => {
                navigateToNextPage(null, result);
            })
            .catch(err => {
                console.log(err, "Person verification error");
            });
    };

    function populateIdTypes(entity, data) {
        let documentType = data[entity]?.documentInfo?.documentType;
        if (isNotNullOrWhitespace(documentType) && lookups.otherDocumentTypes.indexOf(documentType) < 0) {
            data = {
                ...data,
                [entity]: {
                    ...data[entity],
                    documentInfo: {
                        ...data[entity].documentInfo,
                        documentType: "Other",
                        documentTypeOther: documentType,
                    },
                },
            };
        }

        return data;
    }

    function removeTimeFromDobForPatient(data) {
        data = {
            ...data,
            ["patient"]: {
                ...data["patient"],
                dob:
                    data["patient"].dob != null && data["patient"].dob !== ""
                        ? moment.utc(data["patient"].dob).format("YYYY-MM-DD")
                        : data["patient"].dob,
            },
        };
        return data;
    }

    let initialValues = entry;
    initialValues = removeTimeFromDobForPatient(initialValues);
    initialValues = populateIdTypes("patient", initialValues);
    initialValues = populateIdTypes("responsibleParty", initialValues);

    return (
        <div className="wizard-page">
            <h2 className="title">Patient Information</h2>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                onSubmit={onFakeSubmit}
                validationSchema={validationSchema}
                validateOnBlur={true}
                validateOnChange={true}
                render={props => {
                    const { values } = props;
                    const isRequired = formService.isRequired.bind(this, validationSchema, values);
                    return (
                        <PersonalForm
                            {...props}
                            counties={counties}
                            lookups={lookups}
                            onError={onError}
                            isRequired={isRequired}
                            customerJurisdictions={customerJurisdictions}
                            navigateToNextPage={onFormSubmit}
                            encounterStatus={encounterStatus}
                            encounterSource={encounterSource}
                            documentTypes={documentTypes}
                            documents={documents}
                            isLoading={isLoading}
                        />
                    );
                }}
            />
            <div className="required_field_indicator_explained">Indicates required field</div>
        </div>
    );
};

export const InterviewPersonalContainer = connect(
    state => ({
        entry: state.interview.entry,
        encounterStatus: state.interview.encounterStatus,
        lookups: state.interviewLookups.data,
        customerJurisdictions: state.customer.data?.jurisdictions,
        documentTypes: state.interviewLookups.data.documentTypes,
        documents: state.documents.data[(state.interview?.entry?.patient?.personId)] || [],
        counties: state.counties.data,
        encounterSource: state.interview.encounterSource,
        isLoading: state.documents.isLoading === true || state.documents.isInitialized === false,
    }),
    dispatch => ({
        onSubmit: entry => dispatch(interviewActions.setEntry(entry)),
        onError: () => dispatch(interviewActions.setInterviewError("personal")),
    })
)(InterviewPersonal);
